import RealEstateTablet from './real-estate.desktop';

export default RealEstateTablet;
